import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const LogoHeader = () => {
  const handleClick = () => {
    // 🔥 Trigger MobileLayout to slide to Home
    window.dispatchEvent(new Event("go-home"));
  };

  return (
    <motion.div
      onClick={handleClick}
      whileTap={{ scale: 0.96 }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 160, damping: 12 }}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <Box display="flex" alignItems="baseline" gap={0.35}>
        <Typography variant="h5" fontWeight={800} color="#16A34A">
          Life
        </Typography>

        <Typography variant="h5" fontWeight={800} color="#F59E0B">
          Shot
        </Typography>

        <Typography
          variant="caption"
          sx={{ ml: 0.3, opacity: 0.6 }}
        >
          ™
        </Typography>
      </Box>
    </motion.div>
  );
};

export default LogoHeader;
